var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo w-1920"},[_c('div',{staticClass:"logopic w-1200"},[_c('div',{staticClass:"logopic-left"},[_c('img',{attrs:{"src":require("../../../assets/login/logo.gif"),"alt":""}}),_c('div',{staticClass:"about"},[_c('div',{staticClass:"user"},[_vm._v(" "+_vm._s(_vm.msg)+" ")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }